import { Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { QueryStringTypes } from 'src/app/configs/query-string-types';
import { ComparisonOperator } from 'src/app/core/api/models';
import { PageConfig } from 'src/app/core/models/page-config.model';
import { RoutingStateService } from 'src/app/core/services/routing-state.service';
@Component({
  selector: 'app-page-template',
  templateUrl: './page-template.component.html',
  styleUrls: ['./page-template.component.scss'],
  standalone: false,
})
export class PageTemplateComponent {
  //#region properties
  route = inject(ActivatedRoute);
  routingState = inject(RoutingStateService);

  pageNumberAndSorts = '';

  @Input('config') config: PageConfig;
  @Input('bodyClass') input_bodyClass: string = '';
  @Input('titleClass') input_titleClass: string = 'tw-dir-ltr';
  @Input() display: string = '';
  @Input() items: any;
  @Input() showParent: boolean = false;
  @Input() defaultFilters: any[] = [];

  //page btns outputs
  @Output('onAdd') output_onAdd: any = new EventEmitter<boolean>();
  @Output('onClose') output_onClose: any = new EventEmitter<boolean>();
  @Output('onRefresh') output_onRefresh: any = new EventEmitter<boolean>();
  @Output('onShowAuditPage') output_onShowAuditPage: any =
    new EventEmitter<boolean>();
  @Output('onShowFormAudit') output_onShowFormAudit: any =
    new EventEmitter<boolean>();
  @Output('onShowHelpPage') output_onShowHelpPage: any =
    new EventEmitter<boolean>();
  //table outputs
  @Output('sortObject') output_sortObject: any = new EventEmitter<any[]>();
  @Output('comparisonObjects') output_comparisonObject: any = new EventEmitter<
    any[]
  >();
  @Output('pageNumber') output_pageNumber: any = new EventEmitter<any[]>();
  @Output('pageSize') output_pageSize: any = new EventEmitter<any[]>();
  @Output('onSelectAll') output_onSelectAll = new EventEmitter<boolean>();
  @Output('clearQueryString') output_clearQueryString = new EventEmitter<''>();

  //#endregion

  constructor() {}

  //#region page btns outputs

  onCreate(event) {
    this.output_onAdd.emit(event);
  }
  onShowAuditPage(event) {
    this.output_onShowAuditPage.emit(event);
  }
  onShowFormAudit(event) {
    this.output_onShowFormAudit.emit(event);
  }
  onShowHelpPage(event) {
    this.output_onShowHelpPage.emit(event);
  }
  onClose(event) {
    this.output_onClose.emit(event);
  }
  onRefresh(event) {
    this.output_onRefresh.emit(event);
  }

  //#endregion
  url;

  //#region table outputs
  setUrlFromSortItems(event) {
    this.url = new URL(window.location.href);
    if (this.routingState.isNotExceptedPages()) {
      let eventColumns = [];
      event.forEach((item, index) => {
        eventColumns.push(item.columnName);
        for (const entry of this.url.searchParams.entries()) {
          if (
            entry[0].startsWith('sort') &&
            entry[1].endsWith(item.columnName)
          ) {
            this.url.searchParams.delete(entry[0]);
          }
        }
        this.url.searchParams.set(
          'sort' + (index + 1) + '_' + item.sort,
          item.columnName
        );
      });
      for (const entry of this.url.searchParams.entries()) {
        if (entry[0].startsWith('sort') && !eventColumns.includes(entry[1])) {
          this.url.searchParams.delete(entry[0]);
        }
      }

      window.history.pushState(null, '', this.url.toString());
    }
    this.output_sortObject.emit(event);
  }

  setUrlFromComparisonObjects(event) {
    this.url = new URL(window.location.href);
    if (this.routingState.isNotExceptedPages()) {
      this.removeFiltersFromUrl();
      event.forEach((obj) => {
        obj.comparisonObjects.forEach((com, index) => {
          if (obj.logicalComparisonOperator != undefined) {
            if (com.value.length >= 10 && com.value.includes('-')) {
              if (com.operator == ComparisonOperator.GreaterThan) index = 0;
              if (com.operator == ComparisonOperator.LessThan) index = 1;
            }
            this.url.searchParams.set(
              com.field +
                '_' +
                com.operator +
                '_' +
                obj.logicalComparisonOperator +
                '_' +
                index,
              com.value
            );
          } else {
            this.url.searchParams.set(
              com.field + '_' + com.operator,
              (com.value as string).replace(/\ /g, '%20')
            );
          }
        });
      });
      // وقتی فیلترهای پیشفرض را در یوآرال میگذارد کلیدها را پاک نکند
      if (window.location.search.includes('key-')) {
        let params = this.routingState.parseQueryString();
        for (const [key, value] of Object.entries(params)) {
          if (key.startsWith('key-'))
            this.url.searchParams.set(key, value as string);
        }
      }

      window.history.pushState(null, '', this.url.toString());
    }
    this.output_comparisonObject.emit(event);
  }

  removeFiltersFromUrl() {
    // this.url = new URL(window.location.href);
    this.config;
    if (!this.routingState.isNotExceptedPages()) return;

    for (const [key, value] of this.url.searchParams.entries()) {
      if (
        key.toLowerCase() != QueryStringTypes.PageNumber &&
        key.toLowerCase() != QueryStringTypes.PageSize &&
        !key.startsWith(QueryStringTypes.Sort) &&
        (this.showParent == true || !key.startsWith('key-')) // اگر کلید بود حذفش نکن مگر اینکه کامپوننت پرنت باشد
      ) {
        this.url.searchParams.delete(key);
      } else this.pageNumberAndSorts += '&' + key + '=' + value;
    }

    for (const [key, value] of this.url.searchParams.entries()) {
      if (
        key.toLowerCase() != QueryStringTypes.PageNumber &&
        key.toLowerCase() != QueryStringTypes.PageSize &&
        !key.startsWith(QueryStringTypes.Sort) &&
        (this.showParent == true || !key.startsWith('key-'))
      ) {
        this.removeFiltersFromUrl();
      } else {
        this.pageNumberAndSorts = '';
      }
    }
  }

  changePageNumber(event) {
    this.url = new URL(window.location.href);
    this.url.searchParams.set('PageNumber', event);

    window.history.pushState(null, '', this.url.toString());
    this.output_pageNumber.emit(event);
  }

  changePageSize(event) {
    this.url = new URL(window.location.href);
    this.url.searchParams.set('PageSize', event);

    window.history.pushState(null, '', this.url.toString());
    this.output_pageSize.emit(event);
  }
  onSelectAll(event) {
    this.output_onSelectAll.emit(event);
  }
  clearQueryString() {
    if (this.url?.search) this.url.search = '';
    this.output_clearQueryString.emit('');
  }
  //#endregion
}
